// extracted by mini-css-extract-plugin
export var badge = "_ig-2";
export var detailsPanel = "_ig-0";
export var resultRow = "_ig-1";